import React, { useState, useEffect } from "react";
import ComapanyNameDetails from "../../../../components/common/forms/ComapanyNameDetails";
import CompanySearch from "../../../../components/common/forms/CompanySearch";
import DetailsOfShareHolders from "../../../../components/common/forms/DetailsOfShareHolders";
import FormBranch from "../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../components/common/forms/FormButtom";
import FormOtherDetails from "../../../../components/common/forms/FormOtherDetails";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import {
  SSF_details_of_employee,
  ssf_shareholder,
} from "../SSFRegistrationA/SSFregistrationForm";
import FormPayment from "../../../../components/common/forms/FormPayment";
import api from "../../../../api/api";
import { toast } from "react-toastify";
import AdminSearchCustomer from "../../common/AdminSearchCustomer";
import { useSelector } from "react-redux";

const SSFRegistrationB = () => {
  const { register, handleSubmit, unregister } = useForm();
  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null);
  const [uploadProof, setUploadProof] = useState('')
  const [employeeNum,setEmployeeNum] = useState(0)

  


  const [ssfDetail, setSsfDetail] = useState({
    username: "",
    password: "",
    ssid: "",
  });
  const [shareHolders, setShareHolders] = useState([
    {
      ...ssf_shareholder,
      id: uuidv4(),
    },
  ]);

  const [receivedAmount, setReceivedAmount] = useState([])
  const [dueAmount, setDueAmount] = useState(null);
  const [paidAmount, setPaidAmount] = useState(null);
  const [amount, setAmount] = useState(0)


  useEffect(() => {
    console.log('received', receivedAmount)
    console.log('employeeNum',employeeNum)
    if(receivedAmount.length > 0) {
      if(employeeNum > 4)  {
          setAmount(employeeNum * receivedAmount[0]?.amount)
        }else if(employeeNum > 0){
          setAmount(receivedAmount[1]?.amount)
        } else if(employeeNum === ""){
          setAmount(0)
        }   
    }

  }, [employeeNum, receivedAmount])
  



     // getting current user
     useEffect(() => {
      api
        .get("/users/me/")
        .then((response) => {
          setDueAmount(response.due_amount);
        })
        .catch((error) => {});
    }, []);


    // for filtering company_type and employer
    useEffect(() => {
      api.get('/services/company/registration/service-charges/?company_type=ssf&ssf_form_type=employee')
      .then(response => {
          console.log(response.data)
          setReceivedAmount(response.data)
      }).catch(error=> {
  
      })
    }, []);


  




  const handleChange = (e) => {
    setSsfDetail((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleClick = (data) => {
    data.ssf_detail = ssfDetail;
    data.employees = shareHolders;

    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID;
      }
    }

    api
      .post("services/company/", data)
      .then((response) => {
        // console.log(respone.data)
        toast.success("Data Registered Successfully.");

        let transactions = {
          amount: paidAmount,
          service_object_id: response.data.registration_id,
          created_by: response.data.registration_id,
          service_object_content_type: response.data.service_content_type_id,
          payment_proof : uploadProof,
          company : response.data.company_id,
          transaction_type: "credit"
       
        };

        api
          .post("/transactions/", transactions)
          .then((response) => {
            toast.success("Data Registered 2 Successfully.");
          })
          .catch((error) => {
            toast.error("Error in Transaction");
          });
      })
      .catch((error) => {
        toast.error("Data Registration Failed.");
      });
  };

  return (
    <form>
      <div className="mt-3">
        {(user?.user_type === "ST" || user?.user_type === "AD") && (
          <AdminSearchCustomer setUserId={setUserId} />
        )}
      </div>

      <div className="flex justify-between">
        <p className="text-primary-blue font-Calistoga text-lg my-3 underline">
          1. Company Name & Other Details
        </p>
        <p className="text-primary-red flex">
          Firm No.
          <span className=" text-primary-blue"> 1234</span>
        </p>
      </div>
      <CompanySearch register={register} />

      <div className="overflow-x-auto mt-4                                                                                                ">
        <div className="w-full ">
          <div className="grid md:grid-cols-2 grid-cols-1 border-2 border-primary-blue ">
              <div className="border-primary-blue text-primary-red border-b md:border-r p-2 text-center text-lg font-bold">
                Company Name
              </div>

              <div className="border-primary-blue flex items-center text-primary-red border-b     p-2 text-base font-bold sm:text-lg">
                <input
                  className="text-primary-blue pl-2"
                  {...register(`company_name`, {
                    // required: false,
                  })}
                />
              </div>
              <div className="border-primary-blue px-3 text-primary-red border-b md:border-r text-center p-2 text-sm md:text-lg font-bold">
                Company Address
              </div>
              <div className="border-primary-blue flex items-center text-primary-red border-b    p-2 text-base font-bold sm:text-lg">
                <input
                  className="text-primary-blue pl-2"
                  {...register(`company_address`, {
                    // required: false,
                  })}
                />
              </div>
              <div className="border-primary-blue px-3 text-primary-red border-b md:border-r p-2 text-center text-sm md:text-lg font-bold">
                SSF Username, Password & SSID
              </div>
              <div className="border-primary-blue grid text-primary-red border-b text-base   p-2 font-bold sm:text-lg">
                <div className="flex md:flex-row flex-col">
                  <p>Username: </p>
                  <input
                    className="text-primary-blue pl-2"
                    name="username"
                    onChange={(e) => {
                      setSsfDetail((prevState) => ({
                        ...prevState,
                        [e.target.name]: e.target.value,
                      }));
                    }}
                  />
                </div>
                <div className="flex md:flex-row  flex-col">
                  <p>Password: </p>
                  <input
                    className="text-primary-blue pl-2"
                    name="password"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </div>
                <div className="flex  md:flex-row flex-col">
                  <p>SSID: </p>
                  <input
                    className="text-primary-blue pl-2"
                    name="ssid"
                    onChange={(e) => {
                      setSsfDetail((prevState) => ({
                        ...prevState,
                        [e.target.name]: e.target.value,
                      }));
                    }}
                  />
                </div>
              </div>

              <div className="border-primary-blue text-primary-red border-b md:border-b-0  p-2 md:border-r text-center p-2 px-3 text-sm md:text-lg font-bold">
                Entry गर्नुपर्ने जम्मा Employee हरुको संख्या
              </div>
              <div className="border-primary-blue flex text-primary-red  text-base p-2 font-bold sm:text-lg">
                जना :
                <input
                  className="text-primary-blue pl-2 "
                  name="employee_num"
                  {...register(`employee_num`, {
                    // required: false,
                    onChange : (e) => {
                      setEmployeeNum(e.target.value) 
                    }
                  })}
                />
              </div>
          </div>
        </div>
        <div className="w-full text-center bg-red-200 p-2 border text-primary-blue border-x-2 border-b-2 font-Laila font-bold border-primary-blue border-t-0">
          Entry गर्नुपर्ने कर्मचारीहरुको संख्याको आधारमा तपाईको जम्मा लाग्ने रकम{" "}
          <span className="text-red-600"> रु.{amount}।– </span> मात्र
        </div>
      </div>
      <div className="text-primary-blue text-center my-3 font-Laila text-base font-semibold">
        एकैपटकमा ४ जना भन्दा बढि कर्मचारीहरुको ईन्ट्री गर्नुपर्ने भएमा प्रती
        ब्यक्ति ३०० को दरले लाग्नेछ, तर ४ जना भन्दा कमको संख्यामा ईन्ट्री गर्दा
        एकमुस्ट १२०० लाग्नेछ ।
      </div>
      <p className="text-primary-blue font-Calistoga  flex text-lg underline">
        2. Details of Emloyee
        <span className=" text-primary-blue font-Laila">
          (ईन्ट्री गर्नुपर्ने कर्मचारीहरुको सम्पूर्ण विवरण यो तालिकामा भर्नुहोस्
          ।)
        </span>
      </p>

      <DetailsOfShareHolders
        DetailShareholder={SSF_details_of_employee}
        needed_share={ssf_shareholder}
        setShareHolders={setShareHolders}
        shareHolders={shareHolders}
      />

      {/* share holder details form */}
      {/* <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
              <div className="min-w-[1300px] overflow-x-auto">
                <div id="tbl_posts">
                  <div>
                    <div>
                      <div className="border-primary-blue  text-primary-red border text-lg font-bold">
                        क्र. स.
                      </div>
                      <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                        कर्मचारीहरुको नाम
                      </div>
                      <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                        हालको ठेगाना
                      </div>

                      <div className="border-primary-blue text-primary-red border border-r-0 text-base font-bold sm:text-lg">
                        मो. नं.
                      </div>
                      <div className="border-primary-blue text-primary-red border border-r text-base font-bold sm:text-lg">
                        ईमेल
                      </div>
                      <div className="border-primary-blue text-primary-red border border-r-0 text-base font-bold sm:text-lg">
                        पद
                      </div>
                      <div className="border-primary-blue text-primary-red border border-r text-base font-bold sm:text-lg">
                        नियुक्ती मिति
                      </div>
                      <div className="border-primary-blue text-primary-red border border-r-0 text-base font-bold sm:text-lg">
                        खाता नं.
                      </div>
                      <div className="border-primary-blue text-primary-red border border-r text-base font-bold sm:text-lg">
                        नागरिकता
                      </div>
                      <div className="border-primary-blue text-primary-red border border-r text-base font-bold sm:text-lg">
                        फोटो
                      </div>
                    </div>
                  </div>
                  <div id="tbl_posts_body">
                    <div id="rec-1" className="border-primary-blue border">
                      <div className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                        1
                      </div>
                      <div className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </div>
                      <div className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </div>
                      <div className="p-0">
                        <input
                          type="number"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </div>

                      <div className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue file:bg-primary-blue m-0 w-full  border-r cursor-pointer py-3 px-3 outline-none file:rounded-2xl file:text-white"
                          id=""
                        />
                      </div>
                      <div className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue file:bg-primary-blue m-0 w-full  border-r cursor-pointer py-3 px-3 outline-none file:rounded-2xl file:text-white"
                          id=""
                        />
                      </div>
                      <div className="p-0">
                        <input
                          type="date"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </div>
                      <div className="p-0">
                        <input
                          type="number"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </div>

                      <div className="p-0">
                        <input
                          type="file"
                          name=""
                          className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer border-r py-3 px-3 outline-none file:rounded-2xl file:text-white"
                          id=""
                        />
                      </div>
                      <div className="p-0">
                        <input
                          type="file"
                          name=""
                          className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer py-3 px-3 outline-none file:rounded-2xl file:text-white"
                          id=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
             
              </div>
            </div>
          </div>
        </div> */}
      {/* details of share holders close */}
      <div className="text-primary-blue font-Calistoga text-lg mt-6 mb-6 underline">
        3.Working Branch
        <span className="text-primary-blue underline mx-2 font-Laila">
          (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा
          नजिक पर्छ छनोट गर्नुहोस् ।)
        </span>
      </div>
      <FormBranch register={register} />
      <FormButtom />
      <FormPayment handleSubmit={handleSubmit} handleClick={handleClick}
        setUploadProof={setUploadProof}
        dueAmount = {dueAmount}
        setPaidAmount = {setPaidAmount}
        totalAmount={amount}


      
      />
    </form>
  );
};

export default SSFRegistrationB;
